import OrganisationTypeEnum from '@constants/enums/organisation/type';

import FundManagerApi from '@packages/fund-managers/api';

import { Organisation, Product } from '@/models';

export class FundManager extends Organisation {
    static name = 'FundManager';
    static entity = 'fundManagers';
    static Api = FundManagerApi;

    static fields() {
        return {
            ...super.fields(),
            type: this.enum(OrganisationTypeEnum, OrganisationTypeEnum.FUND_MANAGER).nullable(),
            overview: this.attr(null).nullable(),
            products: this.hasMany(Product, 'company_id')
        };
    }
}

export default FundManager;
